// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import CarouselScrollController from "./carousel_scroll_controller"
application.register("carousel-scroll", CarouselScrollController)

import SlideController from "./slide_controller"
application.register("slide", SlideController)

import LikeAnimateController from "./like_animate_controller"
application.register("like-animate", LikeAnimateController)
